"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMethodDisallowingBody = isMethodDisallowingBody;
/**
 * Return whether body is allowed for this HTTP method.
 */
function isMethodDisallowingBody(method) {
    method = method.toUpperCase();
    return method === "GET" || method === "HEAD";
}
//# sourceMappingURL=UrlQs.js.map